<template>
  <div class="row">
    <div class="col-12">
      <c-table
        ref="table"
        title="개선 목록"
        tableId="impr01"
        :columns="gridImpr.columns"
        :data="riskReduce.imprs"
        :merge="gridImpr.merge"
        :usePaging="false"
        gridHeight="680px"
        @linkClick="linkClick"
      >
        <template v-slot:customArea="{ props, col }">
          <template v-if="col.name === 'riskHazardPicture'">
            <q-icon
              size="sm"
              color="teal"
              name="image"
              class="cursor-pointer"
              @click.stop="openHazardPicture(props)"
            />
          </template>
          <template v-else-if="col.name === 'picture'">
            <q-icon
              size="sm"
              color="blue"
              name="image"
              class="cursor-pointer"
              @click.stop="openImprPicture(props)"
            />
          </template>
        </template>
      </c-table>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "riskTab",
  props: {
    param: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: "",
        ramStepCd: "",
        ramTechniqueCd: "",
        searchRiskReduce: {
          flag: "",
          isSearch: false,
        },
        searchScenario: {
          flag: "",
          isSearch: false,
        },
        planUpdateBtnData: {
          title: "계획",
          flag: false,
          research: "",
        },
      }),
    },
    height: {
      type: String,
      default: function () {
        return "";
      },
    },
  },
  data() {
    return {
      editable: true,
      tab: "impr",
      imprComponent: () => import(`${"@/pages/ram/4m/risk/4mImpr.vue"}`),
      riskReduce: {
        imprs: [],
        riskbooks: [],
      },
      gridImpr: {
        merge: [
          { index: 0, colName: "processName" },
          { index: 1, colName: "jobName" },
          { index: 2, colName: "ram4mRiskHazardClassGroup" },
          { index: 3, colName: "ram4mAssessScenarioId" },
          { index: 4, colName: "ram4mAssessScenarioId" },
          { index: 5, colName: "ram4mAssessScenarioId" },
          { index: 6, colName: "ram4mAssessScenarioId" },
          { index: 7, colName: "ram4mAssessScenarioId" },
          { index: 8, colName: "ram4mAssessScenarioId" },
          { index: 9, colName: "ram4mAssessScenarioId" },
        ],
        columns: [
          {
            name: "processName",
            field: "processName",
            label: "공정",
            align: "left",
            style: "width:100px",
            sortable: false,
          },
          {
            name: "jobName",
            field: "jobName",
            label: "작업",
            align: "left",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "ram4mRiskHazardClassName",
            field: "ram4mRiskHazardClassName",
            label: "평가구분(4M)",
            align: "center",
            style: "width:90px",
            sortable: false,
          },
          {
            name: "riskHazardPicture",
            field: "riskHazardPicture",
            label: "사진",
            align: "center",
            style: "width:40px",
            sortable: false,
            type: "custom",
          },
          {
            name: "riskHazardName",
            field: "riskHazardName",
            label: "유해위험요인",
            align: "left",
            style: "width:170px",
            sortable: false,
          },
          // {
          //   name: "damageTargetName",
          //   field: "damageTargetName",
          //   label: "피해대상",
          //   align: "left",
          //   style: "width:120px",
          //   sortable: false,
          // },
          {
            name: "damageTypeNameName",
            field: "damageTypeNameName",
            label: "재해형태",
            align: "left",
            style: "width:90px",
            sortable: false,
          },
          {
            name: "existingRiskManagementActivities",
            field: "existingRiskManagementActivities",
            label: "현재안전조치",
            align: "left",
            style: "width:180px",
            sortable: false,
          },
          {
            name: "picture",
            field: "picture",
            label: "개선 전/후 사진",
            align: "center",
            type: "custom",
            style: "width:70px",
            sortable: false,
          },
          {
            name: "addingRiskManagementActivities",
            field: "addingRiskManagementActivities",
            label: "개선방향(대책)",
            align: "left",
            style: "width:180px",
            sortable: false,
          },
          {
            name: "ibmTitle",
            field: "ibmTitle",
            label: "제목",
            align: "left",
            type: "link",
            style: "width:300px",
            sortable: true,
          },
          {
            name: "ibmStepName",
            field: "ibmStepName",
            label: "진행상태",
            align: "center",
            style: "width:100px",
            sortable: false,
          },
          {
            name: "actionCompleteDate",
            field: "actionCompleteDate",
            label: "조치일",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
        ],
        height: "500px",
      },
      imprData: null,
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        width: "80%",
        param: {},
        closeCallback: null,
      },
    };
  },
  watch: {
    "param.searchRiskReduce.flag"() {
      this.getList();
    },
    "param.planUpdateBtnData.research"() {
      this.getList();
    },
  },
  computed: {
    listUrl() {
      let url = null;
      if (this.param.ramTechniqueCd === "RT00000001") {
        // HAZOP
        url = selectConfig.ram.hazop.riskReduce.list.url;
      } else if (this.param.ramTechniqueCd === "RT00000005") {
        // K-PSR
        url = selectConfig.ram.kpsr.riskReduce.list.url;
      } else if (this.param.ramTechniqueCd === "RT00000010") {
        // Check-list
        url = selectConfig.ram.checklist.riskReduce.list.url;
      } else if (this.param.ramTechniqueCd === "RT00000015") {
        // JRA
        url = selectConfig.ram.jsa.riskReduce.list.url;
      } else if (this.param.ramTechniqueCd === "RT00000020") {
        // KRAS
        url = selectConfig.ram.kras.riskReduce.list.url;
      } else if (this.param.ramTechniqueCd === "RT00000025") {
        // 4M
        url = selectConfig.ram.fm.riskReduce.impr.url;
      } else if (this.param.ramTechniqueCd === "RT00000030") {
        // CHARM
        url = selectConfig.ram.charm.riskReduce.list.url;
      }
      return url;
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      // url setting
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = {
        ramRiskAssessmentPlanId: this.param.ramRiskAssessmentPlanId,
      };
      this.$http.request((_result) => {
        this.riskReduce.imprs = _result.data;
      });
    },
    linkClick(row) {
      this.imprData = row;
      this.popupOptions.title = "개선 상세";
      this.popupOptions.param = {
        sopImprovementId: row.sopImprovementId,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/sop/ibm/imprDetail.vue"}`);
      this.popupOptions.width = "80%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeImprPopup;
    },
    closeImprPopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
    openHazardPicture(_props) {
      this.popupOptions.title = "유해위험요인 사진";
      this.popupOptions.param = {
        ramRiskHazardId: _props.row.ramRiskHazardId,
        disabled: true,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/common/hazard/riskHazardPicture.vue"}`);
      this.popupOptions.width = "30%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeImprPopup;
    },
    openImprPicture(_props) {
      this.popupOptions.title = "개선 사진";
      this.popupOptions.param = {
        ram4mAssessScenarioId: _props.row.ram4mAssessScenarioId,
        sopImprovementIds: _props.row.sopImprovementIds,
        // ram4mAssessImprIds: _props.row.ram4mAssessImprIds,
        disabled: true,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/ram/4m/action/4mScenarioImprPicture.vue"}`);
      this.popupOptions.width = "60%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeImprPopup;
    },
  },
};
</script>
